import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const CarouselWrapper = styled.div`
  width: 100%;
`;

export const CarouselHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space[4]};
`;

export const CarouselTitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const ArrowGroup = styled.div`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: flex;
    gap: ${space[2]};
  }
`;

export const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease, border-color 0.2s ease;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    background: ${colors.lighterGrey};
    border-color: ${colors.grey};
  }

  svg {
    width: ${space[4]};
    height: ${space[4]};
    color: ${colors.fontPrimary};
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  gap: ${space[4]};
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: var(--carousel-child-width-mobile, var(--carousel-child-width));

    @media (min-width: ${layout.desktopBreakpoint}) {
      width: var(--carousel-child-width);
    }
  }
`;

export const ProgressTrack = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${space[5]};
`;

export const ProgressBarOuter = styled.div`
  width: 80px;
  height: 3px;
  background: ${colors.borderGrey};
  border-radius: 2px;
  overflow: hidden;
  position: relative;
`;

export const ProgressBarInner = styled.div`
  height: 100%;
  background: ${colors.fontPrimary};
  border-radius: 2px;
  position: absolute;
  left: 0;
  transition: left 0.05s ease-out;
`;
